import { isAutocompletePopperOpen } from "~/keyboard/inputSuppression";

const shouldSubmitOnEnter = (
	event: Pick<KeyboardEvent, "ctrlKey" | "defaultPrevented" | "metaKey" | "target">,
	doc: Document = document,
	dialogRoot?: Element | null
): boolean => {
	if (event.defaultPrevented) return false;
	if (isAutocompletePopperOpen(doc)) return false;
	const target = event.target;
	const isFromOutsideTheDialog =
		dialogRoot != null && target instanceof Node && target !== doc.body && !dialogRoot.contains(target);
	if (isFromOutsideTheDialog) return false;
	if (target instanceof HTMLElement) {
		if (target.tagName.toLowerCase() === "textarea") return false;
		const actsOnEnter = target.tagName.toLowerCase() === "button" || target.matches("a[href]");
		if (actsOnEnter && !event.ctrlKey && !event.metaKey) return false;
		const role = target.getAttribute("role");
		if (role === "listbox" || role === "option") return false;
	}
	return true;
};

// MUI portals each dialog, sheet and ask to its own child of <body>, so an ask's Enter comes from outside the host's.
export const findBodyChildAncestor = (element: Element | null): Element | null => {
	let root = element;
	while (root?.parentElement && root.parentElement !== root.ownerDocument.body) root = root.parentElement;
	return root;
};

export default shouldSubmitOnEnter;
